import {
  AUTH_ACTIONS_CLASS,
  AUTH_CONTAINER_CLASS,
  AUTH_FIELDS_CLASS,
  AUTH_LINKS_ROW_CLASS,
  AUTH_LINK_CLASS,
  AuthPage,
  AuthPrimaryButton,
  AuthTextField,
} from "@/components/auth";

import { useLoginForm } from "@/hooks";
import { ReactHookFormDevelopmentTools } from "../../components/developmentTools";
import { Form, FormRootError } from "../../components/forms";
import { RouteLink } from "../../components/ui";

// Email handed off by the signup flow. Read non-destructively: StrictMode's
// double mount would otherwise consume it on the discarded first pass. The key
// is session-scoped and only ever prefills this form.
const consumeSignupEmail = (): string => {
  try {
    return sessionStorage.getItem("fundy:lastSignupEmail") ?? "";
  } catch {
    return "";
  }
};

export const Login = () => {
  const {
    form,
    form: {
      formState: { isSubmitting },
      control,
    },
    handleSubmit,
  } = useLoginForm({ defaultValues: { email: consumeSignupEmail(), password: "" } });

  return (
    <Form {...form}>
      <div className={AUTH_CONTAINER_CLASS}>
        <form
          className="grid gap-6"
          onSubmit={handleSubmit}
        >
          <AuthPage
            title="Login"
            subtitle="Welcome back! Sign in to your account to continue managing your fundraising journey, connect with investors, and access your deal pipeline."
          >
            <div className={AUTH_FIELDS_CLASS}>
              <FormRootError />

              <AuthTextField
                control={form.control}
                name="email"
                label="Email"
                inputProps={{ type: "email", placeholder: "Enter your email address" }}
              />

              <AuthTextField
                control={form.control}
                name="password"
                label="Password"
                inputProps={{ type: "password", placeholder: "Enter your password" }}
              />

              <div className={AUTH_ACTIONS_CLASS}>
                <AuthPrimaryButton
                  disabled={isSubmitting}
                  isLoading={isSubmitting}
                >
                  Login
                </AuthPrimaryButton>
              </div>

              <div className={AUTH_LINKS_ROW_CLASS}>
                <RouteLink
                  to="/auth/signup"
                  className={AUTH_LINK_CLASS}
                >
                  Register
                </RouteLink>
                {" | "}
                <RouteLink
                  to="/auth/forgotPassword"
                  className={AUTH_LINK_CLASS}
                >
                  Forgot my password
                </RouteLink>
              </div>
            </div>
          </AuthPage>
        </form>

        <ReactHookFormDevelopmentTools
          // @ts-expect-error - FIXME:
          control={control}
          placement="top-left"
        />
      </div>
    </Form>
  );
};
